export const delivery_man ='Delivery Man'
export const preseller ='Preseller'
export const salesman ='Salesman'
export const dd_supervisor ='DD Supervisor'
export const horeca_supervisor ='Horeca Supervisor'
export const sdr ='SDR'
export const horeca_ps ='Horeca PS'

export const HORECA_POSITIONS = [horeca_ps]

export function channelIncludes40(selectedChannel: unknown): boolean {
  if (selectedChannel == null || selectedChannel === "") return false;
  const ids = Array.isArray(selectedChannel) ? selectedChannel : [selectedChannel];
  return ids.some((id) => Number(id) === 40 || id === "40");
}

export function getFinanceReportPositions(selectedChannel: unknown): string[] {
  const base = [salesman, preseller];
  return channelIncludes40(selectedChannel) ? [...base, horeca_ps] : base;
}

export function isExplicitHorecaChannelSelected(selectedChannel: unknown): boolean {
  if (!Array.isArray(selectedChannel) || selectedChannel.length === 0) return false;
  if (selectedChannel.includes("all")) return false;
  return channelIncludes40(selectedChannel);
}

export function getMapViewPositions(
  savedMode: string | null,
  isSupervisorUser: boolean,
  selectedChannel: unknown
): string[] {
  if (savedMode === "My Team") {
    if (isSupervisorUser) return [dd_supervisor, horeca_supervisor];
    const base = [preseller, salesman];
    return isExplicitHorecaChannelSelected(selectedChannel)
      ? [...base, horeca_ps]
      : base;
  }
  if (savedMode === sdr) return [sdr];
  if (isSupervisorUser) return [dd_supervisor, horeca_supervisor];
  return [delivery_man];
}